export interface IParams {
  email: string
  firstName: string
  lastName: string
  password: string
}

export function initialParams(): IParams {
  return {
    email: '',
    firstName: '',
    lastName: '',
    password: '',
  }
}
